/**
 * Created by jayed.talukder on 9/13/2018.
 */
import { FieldDefinition } from '@shared/models/field-definition';
import { PagedResponse } from '@shared/models/paged-response-model';
import { LOAD_PROJECT_SUCCESS, ProjectActions } from '../../../../projects/store/actions/projects.actions';
import {EntitySetting} from '../../../models/entity-setting.model';
import {PaymentStreamSetting} from '../../../models/payment-stream-setting.model';
import {ChangeReportProjectTopicModel} from '../../../entity-chart/models/entity-chart.models';
import {
  ADD_TRANSACTION_SUCCESS, CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES_SUCCESS, DELETE_ALL_TRANSACTION_SUCCESS,
  GET_STREAMS_SUCCESS,
  GET_TRANSACTION_FIELD_DEFINATIONS_SUCCESS,
  GET_TRANSACTIONS_SUCCESS,
  GetStreamsActionSuccess, GetTransactionFieldDefinationsSuccessAction, GetTransactionsSuccessAction,
  SET_PAYING_ENTITIES, SET_RECEIVING_ENTITIES, SetPayingEntitiesAction, SetReceivingEntitiesAction,
  TransactionActions, TransactionAddActionSuccess
} from '../actions/transaction.actions';


export interface TransactionState {
  payingEntities: EntitySetting[];
  receivingEntities: EntitySetting[];
  streams: PaymentStreamSetting[];
  transactionTopics: ChangeReportProjectTopicModel[];
  transactions: PagedResponse;
  transactionFieldDefinations: FieldDefinition[];
  refreshSelectionCounter: number;
}

const initialState: TransactionState = <TransactionState>{
  payingEntities          : [],
  receivingEntities       : [],
  streams                 : [],
  transactionTopics       : [],
  transactions            : new PagedResponse(),
  transactionFieldDefinations: [],
  refreshSelectionCounter : 0
};

export function transactionReducer (state = initialState, action: TransactionActions
  | ProjectActions) {
  switch (action.type) {
    case SET_PAYING_ENTITIES:
      return {
        ...state,
        payingEntities: [...(action as SetPayingEntitiesAction).payload]
      };
    case SET_RECEIVING_ENTITIES:
      return {
        ...state,
        receivingEntities: [...(action as SetReceivingEntitiesAction).payload]
      };
    case GET_STREAMS_SUCCESS:
      return {
        ...state,
        streams: [...(action as GetStreamsActionSuccess).payload]
      };
    case ADD_TRANSACTION_SUCCESS:
      const payload = (action as TransactionAddActionSuccess).payload.Payload[0];
      const payloadArray = (action as TransactionAddActionSuccess).payload.Payload;
      const payingEntitySettings = [...state.payingEntities];

      const newPayingEntities = payingEntitySettings.map(pe => {

        if (pe.entity.id === payload.PayingEntity.Id) {
          return {...pe, isChecked: true};
        }
        return {...pe};
      });

      const receivingEntitySettings = [...state.receivingEntities];
      const newReceivingEntities = receivingEntitySettings.map(re => {

        if (re.entity.id === payload.ReceivingEntity.Id) {
          return {...re, isChecked: true};
        }
        return {...re};
      });

      const streams = [...state.streams];
      const newStreams = streams.map(s => {
        const matchedPayload = payloadArray.find(x => {
          return s.stream.id === x.Stream.Id;
        });
        if (matchedPayload) {
          return {...s, isChecked: true};
        } else {
          return {...s};
        }
      });

      return {
        ...state,
        payingEntities   : newPayingEntities,
        receivingEntities: newReceivingEntities,
        streams          : newStreams
      };

    case GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: (action as GetTransactionsSuccessAction).pagedResponse
      };

    case GET_TRANSACTION_FIELD_DEFINATIONS_SUCCESS:
      return {
        ...state,
        transactionFieldDefinations: (action as GetTransactionFieldDefinationsSuccessAction).payload
      };
    case LOAD_PROJECT_SUCCESS:
      return {
        ...initialState
      };
    case CREATE_TRANSACTION_BETWEEN_MY_COUNTRIES_SUCCESS:
      return {
        ...state,
        refreshSelectionCounter: state.refreshSelectionCounter + 1
      };
    case DELETE_ALL_TRANSACTION_SUCCESS:
      return {
        ...state,
        refreshSelectionCounter: state.refreshSelectionCounter + 1
      };
  }
  return state;
}

